import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import Api from '../../../../helpers/api';

const api = new Api('interviews/:id');

function* loadData({ payload: { interview_id } }) {
  try {
    const interview = yield call(sendRequest, api.load, { id: interview_id }, notifications.REQUEST_ERROR);

    if (interview) {
      yield put(actions.loadDataSuccess(interview.data.success.data));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
